import leadValidation from './lead';
import locationValidation from './location';
import joinValidation from './joinDetails';
import appMiddleware from './app';
import throttled from './throttled';

export default [
    throttled,
    leadValidation,
    locationValidation,
    joinValidation,
    appMiddleware
];
